import { Collapse, TableCell, TableRow } from '@mui/material';
import React, { useState } from 'react';
import { Collapser } from 'components';
import { TableEmptyRowProps } from './TableEmptyRowProps';
export const TableEmptyRow = ({ formComponent }: TableEmptyRowProps) => {
    const [open, setOpen] = useState(false);

    return (
        <>
            <TableRow sx={{ '& > *': { borderBottom: 'unset' } }} onClick={() => setOpen(!open)} key={'empty'}>
                <TableCell>
                    <Collapser isAdd={true} open={open} />
                </TableCell>
                <TableCell component='th' scope='row'></TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={10}>
                    <Collapse in={open} timeout='auto'>
                        {formComponent}
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    );
}
